class DetailsModal extends HTMLElement {

  constructor() {

    super();

    this.details = this.querySelector('details');

    this.summary = this.querySelector('summary');

    this.content = this.querySelector('.modal__content');

    this.button = this.querySelector('button[type="button"]');



    this.details.addEventListener('toggle', (event) => {

      if (this.details.open) {

        this.onOpen();

      } else {

        this.onClose();

      }

    });



    if (this.button) {

      this.button.addEventListener('click', this.close.bind(this));

    }

  }



  isOpen() {

    return this.details.hasAttribute('open');

  }



  onOpen() {

    document.body.classList.add('overflow-hidden');

    

    // Focus the input if it exists

    const input = this.querySelector('input[type="search"]');

    if (input) input.focus();



    document.addEventListener('keydown', this.onKeydown.bind(this));

    document.addEventListener('click', this.onBodyClick.bind(this));

  }



  onClose() {

    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('keydown', this.onKeydown.bind(this));

    document.removeEventListener('click', this.onBodyClick.bind(this));

  }



  onKeydown(event) {

    if (event.code.toUpperCase() === 'ESCAPE') {

      this.close();

      this.summary.focus();

    }

  }



  onBodyClick(event) {

    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {

      this.close();

    }

  }



  close() {

    this.details.removeAttribute('open');

  }

}



customElements.define('details-modal', DetailsModal);

